import { SecurityProfile, SecurityInitOptions, USER_TENANT } from './types';

export const SECURITY_USER_PROFILE_DEFAULT: SecurityProfile = {
    username: '',
    groups: [],
    attributes: {
        tenant: [USER_TENANT.STABLE],
    },
    featureFlags: {},
};

export const SECURITY_INIT_OPTIONS_DEFAULT: SecurityInitOptions = {
    loginRequired: false,
    loginFromIFrame: false,
};
